<template>
  <div class="step-container">
    <div class="step completed" v-bind:class="{ 'completed-line': secondStep || thirdStep || fourthStep }">
      <div class="v-stepper">
        <div class="stepper-circle">
          <span class="stepper-circle-number">1</span>
        </div>
        <div class="stepper-line"></div>
      </div>
    </div>

    <div
      class="step"
      v-bind:class="{ 'completed-line': thirdStep || fourthStep, completed: secondStep || thirdStep || fourthStep }"
    >
      <div class="v-stepper">
        <div class="stepper-circle">
          <span class="stepper-circle-number">2</span>
        </div>
        <div class="stepper-line"></div>
      </div>
    </div>

    <div class="step" v-bind:class="{ 'completed-line': fourthStep, completed: thirdStep || fourthStep }">
      <div class="v-stepper">
        <div class="stepper-circle">
          <span class="stepper-circle-number">3</span>
        </div>
        <div class="stepper-line"></div>
      </div>
    </div>

    <div class="step" v-bind:class="{ completed: fourthStep }">
      <div class="v-stepper">
        <div class="stepper-circle">
          <span class="stepper-circle-number">4</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompetitionStepProgress',
  data() {
    return {
      secondStep: false,
      thirdStep: false,
      fourthStep: false
    }
  },
  mounted() {
    if (this.$route.path.includes('/competition/2')) {
      this.secondStep = true
    } else if (this.$route.path.includes('/competition/3')) {
      this.thirdStep = true
    } else if (this.$route.path.includes('/competition/4')) {
      this.fourthStep = true
    }
  },
  watch: {
    $route() {
      if (this.$route.path.includes('/competition/2')) {
        this.secondStep = true
      } else if (this.$route.path.includes('/competition/3')) {
        this.thirdStep = true
      } else if (this.$route.path.includes('/competition/4')) {
        this.fourthStep = true
      }
    }
  }
}
</script>
<style>
.step-container {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  min-height: 350px;
}
.step {
  height: 100%;
  padding: 10px;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  background-color: cream;
}

.v-stepper {
  position: relative;
  /*   visibility: visible; */
}

/* regular step */
.step .stepper-circle {
  background-color: #c4c4c4;
  border: 3px solid #c4c4c4;
  border-radius: 100%;
  width: 20px; /* +6 for border */
  height: 20px;
  display: instepper-line-block;
}

.step .stepper-line {
  top: 20px;
  left: 9px;
  height: 100%;

  position: absolute;
  border-left: 3px solid #c4c4c4;
}

.step.completed .stepper-circle {
  visibility: visible;
  background-color: #00903c;
  border-color: #00903c;
}

.stepper-circle {
  position: relative;
}

.stepper-circle-number {
  position: absolute;
  margin: -4.6px;
  padding-top: 0.2px;
  color: #fff;
}

.step.completed-line .stepper-line {
  border-left: 3px solid #00903c;
}

.step:last-child {
  height: 0;
}
</style>
